import Image from "next/image";
import { CheckCircleIcon } from "@heroicons/react/24/solid";
import cloudflareLoader from "@/lib/cloudflare-images";

const CookingHabitsFollowUpStep = ({
  stepData,
  handleContinue,
}: {
  stepData: any;
  handleContinue?: () => void;
}) => {
  const habit = stepData?.linkedCookingHabits?.[0];
  const image = stepData?.linkedOptionImages?.[0];
  const bulletPoints = stepData?.bulletPoints || [];

  if (!habit) return null;

  return (
    <div className="space-y-8 px-4 text-left text-black md:text-center">
      {/* Title */}
      <div
        className="font-spatial text-xl font-medium md:text-2xl [&>span]:text-orange-400"
        dangerouslySetInnerHTML={{ __html: stepData.title }}
      />

      {/* Bullet Points */}
      <ul className="space-y-2 pt-2 text-left font-body text-sm font-medium md:text-base">
        {bulletPoints.map((point: any, i: number) => (
          <li key={i} className="flex items-center gap-2">
            <CheckCircleIcon className="h-5 w-5 shrink-0 text-green-500" />
            <span className="block leading-snug">{point?.bulletPoint}</span>
          </li>
        ))}
      </ul>

      {/* Mobile Image Only */}
      {image?.url && (
        <div className="mt-6 block w-full sm:hidden">
          <div className="relative mx-auto h-[180px] w-[260px] overflow-hidden">
            <Image
              src={image.url}
              alt={image.title || "Habit preview"}
              fill
              className="object-cover object-top"
              priority
              loader={cloudflareLoader}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default CookingHabitsFollowUpStep;
